var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add-user"},[_c('div',{staticClass:"add-user-con"},[_c('div',{attrs:{"icon":"log-in","title":"添加用户","bordered":false}},[_c('add-user-form',{on:{"on-success-valid":_vm.handleSubmit}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }